import { Component, inject } from '@angular/core';
import { register } from 'swiper/element/bundle'; // <--- IMPORT REGISTER HERE
import { IconRegistryService } from './services/icon-registry.service';
import { TemaService } from './services/tema/tema.service';

register(); // <--- INIT SWIPER HERE

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  /* **** SERVICES INJECTIONS */
  private readonly iconRegistry = inject(IconRegistryService);

  constructor(private temaService: TemaService) {
    this.temaService.temaUpdated.subscribe((tema) => {
      document.title = temaService.title;
    });

    // Registro le icone necessarie
    this.iconRegistry.registerIcons();
  }
}
